import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import about from '@/components/about'
import blog from '@/components/blog'
import blogs from '@/components/blogs'
import projects from '@/components/projects'
import engineering from '@/components/engineering'
import umbrella from '@/components/umbrella'
import contact from '@/components/contact'
import project from '@/components/project'
import ar from '@/components/ar'

Vue.use(Router)
const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
        path: '/about',
        name: 'about',
        component: about
    },
    {
        path: '/blogs/:slug',
        name: 'blog',
        component: blog,
    },
    {
      path: '/blogs',
      name: 'blogs',
      component: blogs,
    },
      {
      path: '/projects',
      name: 'projects',
      component: projects,
    },
    {
      path: '/engineering',
      name: 'engineering',
      component: engineering,
    },
    {
      path: '/umbrella',
      name: 'umbrella',
      component: umbrella,
    },
    {
      path: '/contact',
      name: 'contact',
      component: contact,
    },
    {
      path: '/project/:slug',
      name: 'project',
      component: project,
    },
    {
      path: '/ar',
      name: 'ar',
      component: ar,
    },
  ]
});
export default router



// WEBPACK FOOTER //
// ./src/router/index.js